export default __webpack_public_path__ + "static/media/img-8.96a98bf0.jpg";